import * as React from 'react';

import './Core.visual.css'

interface ICoreVisualProps {
    resolution: string;
}

class CoreVisual extends React.Component<ICoreVisualProps> {
    public render() {
        /* always show the least supported (according to the Google Material Design guidelines) */
        return (
            <iframe
                className={"CoreVisual CoreVisual--" + this.props.resolution}
                src="/app"
                scrolling="no"
                />
                
        );
    }
}

export default CoreVisual;


// WEBPACK FOOTER //
// ./src/App/Core.visual.tsx